import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterTimePicker, FilterSelectAsync } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import {
  DisplayDate,
  DisplayGuid,
  DisplayBoolean
} from '../items';

const resultsCount = 25;

class ActivitiesInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { activities: { searchActivities } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchActivities({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { history, location, api } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const {
      facilities: { lookupByNameOrId: lookupFacility }
    } = api;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Activities list'
              documentDescription='Activities list'
            />
            <h2 className='main-page-header'>
              Activities
            </h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                activityId,
                productId,
                crawlingId,
                facilityId,
                afterAt,
                beforeAt
              }, updatedKey) => {
                if (updatedKey !== 'activityId') {
                  return {
                    productId,
                    crawlingId,
                    facilityId,
                    afterAt,
                    beforeAt
                  };
                }
                return { activityId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='activityId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='activityId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='productId'>
                      Product Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='productId'
                      placeholder='Filter by product id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='crawlingId'>
                      Crawling Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='crawlingId'
                      placeholder='Filter by crawling id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Facility
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='facilityId'
                      loadOptions={async inputValue => lookupFacility(inputValue)}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'activities',
                rowClasses: 'hover-listview',
                rowClick: ({ id }) => {
                  history.push(`/activity/${id}`);
                },
                columns: [
                  {
                    property: 'id',
                    label: 'Id',
                    render: ({ id }) => <DisplayGuid>{id}</DisplayGuid>
                  }, {
                    property: 'title',
                    label: 'Title',
                    type: 'string'
                  }, {
                    property: 'productName',
                    label: 'ProductName',
                    type: 'string'
                  }, {
                    property: 'facilityName',
                    label: 'FacilityName',
                    type: 'string'
                  }, {
                    property: 'starts At',
                    label: 'Starts At',
                    render: ({ startsAt }) => <DisplayDate>{startsAt}</DisplayDate>
                  }, {
                    property: 'ends At',
                    label: 'Ends At',
                    render: ({ endsAt }) => <DisplayDate>{endsAt}</DisplayDate>
                  }, {
                    property: 'isShadowed',
                    label: 'isShadowed',
                    render: ({ isShadowed }) => <DisplayBoolean>{isShadowed}</DisplayBoolean>
                  }, {
                    property: 'isBuried',
                    label: 'isBuried',
                    render: ({ isBuried }) => <DisplayBoolean>{isBuried}</DisplayBoolean>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);
                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Activities = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ActivitiesInternal)));

Activities.requiresLogin = true;
Activities.propTypes = { isLoggedIn: PropTypes.bool };

export default Activities;